var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopParallax',{attrs:{"title":"PRIVACY STATEMENT","img-src":_vm.imgSrc}}),_c('PrivacyContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }